// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  font-family: Poppins, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
  margin: 0;
  /* allow the page to scroll */
  overflow: auto;
  /* smooth in-page scrolling for anchors and JS scrolls */
  scroll-behavior: smooth;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Thin, themed scrollbar for WebKit browsers */
*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #7b5cff, #a884ff);
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

*::-webkit-scrollbar-thumb:hover {
  filter: brightness(0.95);
}

/* Firefox scrollbar support */
* {
  scrollbar-width: thin;
  scrollbar-color: #7b5cff transparent;
}

.modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border: 1px solid #000;
  box-shadow: 24;
  padding: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/index.css"],"names":[],"mappings":"AAAA;;EAEE,2FAA2F;EAC3F,SAAS;EACT,6BAA6B;EAC7B,cAAc;EACd,wDAAwD;EACxD,uBAAuB;EACvB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf","sourcesContent":["html,\r\nbody {\r\n  font-family: Poppins, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;\r\n  margin: 0;\r\n  /* allow the page to scroll */\r\n  overflow: auto;\r\n  /* smooth in-page scrolling for anchors and JS scrolls */\r\n  scroll-behavior: smooth;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n/* Thin, themed scrollbar for WebKit browsers */\r\n*::-webkit-scrollbar {\r\n  width: 10px;\r\n  height: 10px;\r\n}\r\n\r\n*::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb {\r\n  background: linear-gradient(180deg, #7b5cff, #a884ff);\r\n  border-radius: 10px;\r\n  border: 2px solid transparent;\r\n  background-clip: padding-box;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb:hover {\r\n  filter: brightness(0.95);\r\n}\r\n\r\n/* Firefox scrollbar support */\r\n* {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #7b5cff transparent;\r\n}\r\n\r\n.modal {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: white;\r\n  border: 1px solid #000;\r\n  box-shadow: 24;\r\n  padding: 24px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
